import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from 'react-router-dom';
import firebase from 'firebase/app'; 
import 'firebase/auth'; 
import 'firebase/database';

const firebaseConfig = {
    apiKey: "AIzaSyDOYL1bA0oux-DrkmJZWR7jbUEUFGmppDE",
    authDomain: "uspctrivia.firebaseapp.com",
    databaseURL: "https://uspctrivia.firebaseio.com",
    projectId: "uspctrivia",
    storageBucket: "uspctrivia.appspot.com",
    messagingSenderId: "437801349448",
    appId: "1:437801349448:web:1d2c131c31f46427bf437d",
    measurementId: "G-Z1VYV847L7"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);

ReactDOM.render(<BrowserRouter> <App /> </BrowserRouter>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
